export default __webpack_public_path__ + "static/media/medical_14.c47c8545.jpg";